<div class="sdps-navigation--horizontal">
  <nav aria-label="Admin sub-navigation" class="sdps-navigation--horizontal__levelFour subNavigation" id="unique-secondaryNav">
    <ul class="sdps-navigation--horizontal__nav">
      <ng-container *ngFor="let nav of adminMenuSubMenu">
        <li class="sdps-navigation--horizontal__item" routerLinkActive="sdps-is-active" [ngClass]="!nav.showLink ? 'demo-border-bottom':''">
          <a class="sdps-navigation--horizontal__link" *ngIf="nav.showLink && this.sharedService.checkAccess(nav.accessName)">
            <button class="buttons sub-navigation-button" [routerLink]="nav.route" [ngClass]="!nav.showLink ? 'demo-border-bottom':''"
                    [innerHTML]="nav.name" (click)="sharedService.loadDataTrackValue(nav.route)"></button>
          </a>
          <a class="sdps-navigation--horizontal__link" *ngIf="!nav.showLink && this.sharedService.checkAccess(nav.accessName)" [class.ui-disable-nav-tab]="!nav.showLink ? true: ''"
             [innerHTML]="nav.name" [title]="shellConstant.accessDeniedTooltipMessage"></a>
        </li>
      </ng-container>
    </ul>
  </nav>
  <div class="content-area sdps-p-around_large">
    <ems-service-error *ngIf="sharedService.showHistoricalView | async"></ems-service-error>
    <router-outlet></router-outlet>

  </div>
</div>
